module.exports = __webpack_public_path__ + "media/images/home/icon-handy-4076a82b42072d8beb62942be4703167.png";